import { PERMISSION_WRITE_QC } from "@/utils/permissions";

export const SIDEBAR_EXPANDED_PX = 280;
export const SIDEBAR_COLLAPSED_PX = 64;
export const SIDEBAR_MIN_PX = 220;
export const SIDEBAR_MAX_PX = 440;
export const SIDEBAR_WIDTH_STORAGE_KEY = "fd-sidebar-expanded-width";

const icons = {
  home: require("@/assets/Svg/LeftMenu/data-management.svg"),
  homeActive: require("@/assets/Svg/LeftMenu/data-management-active.svg"),
  qaqc: require("@/assets/Svg/LeftMenu/QA-QC.svg"),
  qaqcActive: require("@/assets/Svg/LeftMenu/QA-QC-active.svg"),
  studio: require("@/assets/Svg/LeftMenu/studio.svg"),
  studioActive: require("@/assets/Svg/LeftMenu/studio-active.svg"),
  dashboards: require("@/assets/Svg/LeftMenu/dashboard.svg"),
  dashboardsActive: require("@/assets/Svg/LeftMenu/dashboard-active.svg"),
  eda: require("@/assets/Svg/LeftMenu/eda.svg"),
  edaActive: require("@/assets/Svg/LeftMenu/eda-active.svg"),
  inventory: require("@/assets/Svg/LeftMenu/inventory.svg"),
  inventoryActive: require("@/assets/Svg/LeftMenu/inventory-active.svg"),
  twod: require("@/assets/Svg/LeftMenu/twod.svg"),
  twodActive: require("@/assets/Svg/LeftMenu/twod-active.svg"),
  statistical: require("@/assets/Svg/LeftMenu/statistical.svg"),
  statisticalActive: require("@/assets/Svg/LeftMenu/statistical-active.svg"),
  correlation: require("@/assets/Svg/LeftMenu/correlation.svg"),
  correlationActive: require("@/assets/Svg/LeftMenu/correlation-active.svg"),
  treemap: require("@/assets/Svg/LeftMenu/treemap.svg"),
  treemapActive: require("@/assets/Svg/LeftMenu/treemap-active.svg"),
  bubble: require("@/assets/Svg/LeftMenu/bubble.svg"),
  bubbleActive: require("@/assets/Svg/LeftMenu/bubble-active.svg"),
  threed: require("@/assets/Svg/LeftMenu/threed.svg"),
  threedActive: require("@/assets/Svg/LeftMenu/threed-active.svg"),
  depth: require("@/assets/Svg/LeftMenu/depth.svg"),
  depthActive: require("@/assets/Svg/LeftMenu/depth-active.svg"),
  intelligence: require("@/assets/Images/LeftMenu/fdpal.svg"),
  intelligenceActive: require("@/assets/Images/LeftMenu/fdpal-active.svg"),
  pvt: require("@/assets/Svg/LeftMenu/pvt-prediction.svg"),
  pvtActive: require("@/assets/Svg/LeftMenu/pvt-prediction-active.svg"),
  agentic: require("@/assets/Svg/LeftMenu/agentic-ai.svg"),
  agenticActive: require("@/assets/Svg/LeftMenu/agentic-ai-active.svg"),
  userMode: require("@/assets/Svg/LeftMenu/user-mode.svg"),
  roleMode: require("@/assets/Svg/LeftMenu/role-mode.svg"),
};

export function buildNavigation(tenantId) {
  const t = tenantId || "";
  return [
    {
      id: "data-management",
      title: "Data Management",
      permission: "ViewDataManagement",
      to: `/${t}/data-management`,
      match: "data-management",
      icon: icons.home,
      activeIcon: icons.homeActive,
    },
    {
      id: "qaqc",
      title: "QA/QC",
      permission: PERMISSION_WRITE_QC,
      to: `/${t}/qaqc/overview`,
      match: "qaqc",
      icon: icons.qaqc,
      activeIcon: icons.qaqcActive,
    },
    {
      id: "ocr",
      title: "OCR / Digitization",
      permission: "ViewDataManagement",
      to: `/${t}/ocr/upload`,
      match: "ocr",
      icon: icons.home,
      activeIcon: icons.homeActive,
    },
    {
      id: "studio",
      title: "Studio",
      permission: "ViewStudio",
      to: `/${t}/Fluidsdata-studio`,
      match: "Fluidsdata-studio",
      icon: icons.studio,
      activeIcon: icons.studioActive,
    },
    {
      id: "agentic-dashboards",
      title: "Dashboard",
      permission: "ViewDashboards",
      to: `/${t}/agentic-dashboard`,
      match: "agentic-dashboard",
      icon: icons.dashboards,
      activeIcon: icons.dashboardsActive,
    },
    {
      id: "eda",
      title: "EDA",
      permission: "ViewEDA",
      icon: icons.eda,
      activeIcon: icons.edaActive,
      children: [
        {
          id: "eda-inventory",
          title: "Inventory Analysis",
          permission: "ViewEDA",
          to: `/${t}/exploratory-data-analysis/inventory-analysis`,
          icon: icons.inventory,
          activeIcon: icons.inventoryActive,
        },
        {
          id: "eda-2d",
          title: "2D Histogram/KDE Analysis",
          permission: "ViewEDA",
          to: `/${t}/exploratory-data-analysis/twodhistogram-kde`,
          icon: icons.twod,
          activeIcon: icons.twodActive,
        },
        {
          id: "eda-stats",
          title: "Statistical Analysis",
          permission: "ViewEDA",
          to: `/${t}/exploratory-data-analysis/statistical-analysis`,
          icon: icons.statistical,
          activeIcon: icons.statisticalActive,
        },
        {
          id: "eda-corr",
          title: "Correlation Analysis",
          permission: "ViewEDA",
          to: `/${t}/exploratory-data-analysis/correlation-analysis`,
          icon: icons.correlation,
          activeIcon: icons.correlationActive,
        },
        {
          id: "eda-heatmap",
          title: "Heatmap Analysis",
          permission: "ViewEDA",
          to: `/${t}/exploratory-data-analysis/heatmap-analysis`,
          icon: icons.treemap,
          activeIcon: icons.treemapActive,
        },
        {
          id: "eda-bubble",
          title: "Bubble Plot Analysis",
          permission: "ViewEDA",
          to: `/${t}/exploratory-data-analysis/bubble-plot-analysis`,
          icon: icons.bubble,
          activeIcon: icons.bubbleActive,
        },
        {
          id: "eda-3d",
          title: "3D Plot Analysis",
          permission: "ViewEDA",
          to: `/${t}/exploratory-data-analysis/3d-plot-analysis`,
          icon: icons.threed,
          activeIcon: icons.threedActive,
        },
        {
          id: "eda-composition",
          title: "Composition Gradient Analysis",
          permission: "ViewEDA",
          to: `/${t}/exploratory-data-analysis/composition-gradient-analysis`,
          icon: icons.depth,
          activeIcon: icons.depthActive,
        },
      ],
    },
    {
      id: "intelligence",
      title: "Fluids Intelligence",
      permission: "ViewDataManagement",
      icon: icons.intelligence,
      activeIcon: icons.intelligenceActive,
      children: [
        {
          id: "pvt-prediction",
          title: "PVT Property Prediction",
          permission: "ViewDataManagement",
          to: `/${t}/pvt-prediction`,
          tenantOnly: "Fluidsdata",
          icon: icons.pvt,
          activeIcon: icons.pvtActive,
        },
        {
          id: "agentic-ai",
          title: "Agentic AI",
          permission: "ViewDataManagement",
          to: `/${t}/fluidsIntelligence`,
          icon: icons.agentic,
          activeIcon: icons.agenticActive,
        },
      ],
    },
  ];
}

export function buildSettingsLinks(tenantId) {
  const t = tenantId || "";
  return [
    {
      id: "users",
      title: "User Management",
      permission: "ManageUsers",
      to: `/${t}/users`,
      icon: icons.userMode,
    },
    {
      id: "roles",
      title: "Role Management",
      permission: "ManageRoles",
      to: `/${t}/roles`,
      icon: icons.roleMode,
    },
  ];
}
